import { useWindowOpen } from '@repo/platform';
import { useUserEventLogger } from '@repo/tracking-service';
import { useAuthContext } from '@repo/user-session';
import { Button } from '@zenterprise-inc/ui';
import { useEffect, useState } from 'react';

import { benefitLandingModalQuery$data } from '@/__generated__/benefitLandingModalQuery.graphql';
import { WaitingModal } from '@/components/landing/WaitingModal';
import { AUTH_PATHS, COMMON_PATHS } from '@/lib/constants/paths';
import { useRandomWaitingModal } from '@/lib/hooks/use-random-waiting-modal';
import { getUrlWithQueryString } from '@/lib/hooks/use-url-with-query-string';

const EventModal = ({ event }: { event?: benefitLandingModalQuery$data['landingModal'] }) => {
  const { openWindow } = useWindowOpen();
  const [isShowEvent, setIsShowEvent] = useState(!!event);
  const { sendViewEvent, sendClickEvent } = useUserEventLogger();
  const { auth } = useAuthContext();
  const { waitingTime, showWaitingModal, waitingCallback, setWaitingCallback } = useRandomWaitingModal();

  const goPage = (buttonType: 'primary' | 'secondary') => {
    const pageTarget = event?.buttons[buttonType].target ?? '_blank';
    const originLink =
      event?.buttons[buttonType].link === AUTH_PATHS.로그인 && auth.status === 'login' ? COMMON_PATHS.환급조회목록 : event?.buttons[buttonType].link;

    sendClickEvent('landing_modal_button_clicked', { buttonType, ...(event?.userEvent ?? {}) });
    setWaitingCallback(() => () => {
      if (originLink) {
        openWindow(getUrlWithQueryString(originLink), pageTarget);
      }
    });
    closeModal();
  };

  const closeModal = () => {
    if (event?.userEvent) {
      sendClickEvent('landing_modal_closed', event.userEvent);
    }
    setIsShowEvent(false);
  };

  useEffect(() => {
    (document.querySelector('html') as HTMLElement).style.overflowY = isShowEvent ? 'hidden' : 'auto';
    return () => {
      (document.querySelector('html') as HTMLElement).style.overflowY = 'auto';
    };
  }, [isShowEvent]);

  useEffect(() => {
    if (event?.userEvent && isShowEvent) {
      sendViewEvent('landing_modal', event.userEvent);
    }
  }, [event?.userEvent, isShowEvent, sendViewEvent]);

  useEffect(() => {
    if (waitingCallback) {
      showWaitingModal();
    }
  });

  return (
    <>
      {isShowEvent && (
        <div className={'fixed left-0 top-0 z-[150] flex h-full w-full items-end justify-center bg-[rgba(15,15,15,0.6)] sm:items-center'}>
          <div className={'relative m-[8px] w-full max-w-[440px] overflow-hidden rounded-[1.25rem]'}>
            <button
              className={
                'blur-[40px]] absolute right-[1rem] top-[1rem] z-10 flex h-[1.75rem] w-[1.75rem] select-none items-center justify-center rounded-full bg-[rgba(0,0,0,0.24)] text-[1.325rem] text-white'
              }
              onClick={closeModal}
            >
              
            </button>
            <div className={`relative m-0 w-full`} style={{ backgroundColor: event?.backgroundColor ?? '#ffffff' }}>
              <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/${event?.imagePath ?? ''}`} width={440} height={506} alt={'event contents'} />
              {(event?.buttons?.primary?.label || event?.buttons?.secondary?.label) && (
                <div className={'flex flex-col gap-2 px-[1.25rem] pb-[1.25rem] pt-[0.5rem]'}>
                  {event?.buttons?.primary?.label && (
                    <Button.Box fullWidth state={'primary'} onClick={() => goPage('primary')}>
                      {event?.buttons.primary.label}
                    </Button.Box>
                  )}
                  {event?.buttons?.secondary?.label && (
                    <Button.Box fullWidth onClick={() => goPage('secondary')}>
                      {event?.buttons.secondary.label}
                    </Button.Box>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {waitingTime > 0 && <WaitingModal waitingTime={waitingTime} callbackFunction={waitingCallback} />}
    </>
  );
};

export default EventModal;
